/* FORZA 2026-10-21 — WhatsApp links vs Shopify's exit interstitial.
   Shopify now injects <shopify-exit-interstitial> on every storefront: clicking an
   http(s) link to a host outside its fixed allowlist opens a full-screen
   "Are you sure you want to leave Forza Performance Group?" page whose PRIMARY button
   sends the visitor BACK. The allowlist (read off the live page) is
     asianbodykits.myshopify.com, forzaaa.com, www.forzaaa.com,
     asianbodykits.account.myshopify.com, inquiries.forzaaa.com, shopify.com, shop.app,
     facebook.com, instagram.com, pinterest.com, snapchat.com, tiktok.com, twitter.com,
     vimeo.com, x.com, youtu.be, youtube.com
   — no whatsapp.com and no wa.me, and a merchant cannot edit it. Verified on the live
   site: it fires on phone AND desktop, for target="_blank" as well as same-tab links.

   Measured on forzaaa.com which routes escape it:
     anchor href="whatsapp://..."            -> no interstitial
     click -> location.href = "whatsapp://"  -> no interstitial
     click -> window.open(httpsUrl,"_blank") -> no interstitial, tab really opens
     (window.open WITH "noopener" returns null — it must not be used here)
     click -> location.href/assign(httpsUrl) -> INTERSTITIAL (the href setter is hooked)
   So: phones go straight into the app through the whatsapp:// scheme (not http, so the
   interstitial ignores it); desktop opens the normal link through window.open.

   The anchor's href is left untouched so the GTM click trigger still reports the same
   api.whatsapp.com URL it has always counted as the WhatsApp conversion. */
(function () {
  var SELECTOR = 'a[href*="api.whatsapp.com"], a[href*="web.whatsapp.com"], a[href*="//wa.me"]';
  var HREF_RE = /(?:api|web)\.whatsapp\.com|\/\/wa\.me\//i;
  var FALLBACK_MS = 1500;

  /* The BestChat widget — the button most visitors actually use — renders its
     channel list inside an OPEN shadow root (<bestchat-inbox-root>), and its
     WhatsApp entry is a plain
       <a href="https://api.whatsapp.com/send?phone=%2B86…" target="_blank">.
     A document-level listener sees event.target RETARGETED to the shadow host, so
     target.closest() finds nothing and the link slipped through. composedPath()
     carries the real node, and the capture phase runs before anything inside the
     widget can stop propagation. */
  function linkFromEvent(event) {
    var path = typeof event.composedPath === "function" ? event.composedPath() : null;
    if (path) {
      for (var i = 0; i < path.length; i++) {
        var node = path[i];
        if (node && node.nodeType === 1 && node.tagName === "A" &&
            node.href && HREF_RE.test(node.href)) return node;
        if (node === document) break;
      }
    }
    var t = event.target;
    return t && t.closest ? t.closest(SELECTOR) : null;
  }

  function parseTarget(href) {
    var phone = "", text = "";
    try {
      var u = new URL(href, window.location.href);
      if (/(^|\.)wa\.me$/i.test(u.hostname)) {
        phone = u.pathname.replace(/\D/g, "");
      } else {
        phone = (u.searchParams.get("phone") || "").replace(/\D/g, "");
      }
      text = u.searchParams.get("text") || "";
    } catch (e) {}
    return { phone: phone, text: text };
  }

  function isHandheld() {
    try {
      if (window.matchMedia && window.matchMedia("(pointer: coarse)").matches) return true;
    } catch (e) {}
    return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");
  }

  document.addEventListener("click", function (event) {
    if (event.defaultPrevented || event.button > 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = linkFromEvent(event);
    if (!link) return;

    var href = link.href;
    var target = parseTarget(href);
    if (!target.phone) return; /* nothing we understand — leave the link alone */

    event.preventDefault();

    if (!isHandheld()) {
      /* No "noopener" feature string here: with it window.open returns null by spec,
         which read as "popup blocked" and sent the click into the interstitial.
         The opener is severed on the handle instead. */
      var win = window.open(href, "_blank");
      if (win) {
        try { win.opener = null; } catch (e) {}
      } else {
        window.location.href = href; /* genuinely blocked: interstitial, but not a dead end */
      }
      return;
    }

    var deepLink =
      "whatsapp://send?phone=" + target.phone +
      (target.text ? "&text=" + encodeURIComponent(target.text) : "");
    var left = false;
    var markLeft = function () { left = true; };
    document.addEventListener("visibilitychange", markLeft);
    window.addEventListener("pagehide", markLeft);

    window.location.href = deepLink;

    window.setTimeout(function () {
      document.removeEventListener("visibilitychange", markLeft);
      window.removeEventListener("pagehide", markLeft);
      /* still here => WhatsApp is not installed; window.open keeps the interstitial away */
      if (!left && !document.hidden) {
        var fallback = "https://wa.me/" + target.phone +
          (target.text ? "?text=" + encodeURIComponent(target.text) : "");
        var fb = window.open(fallback, "_blank");
        if (fb) { try { fb.opener = null; } catch (e) {} }
      }
    }, FALLBACK_MS);
  }, true); /* capture: shadow-DOM widgets stop propagation before document */
})();
